import SiteView from './Component';

export default SiteView;